export const uiColumnToExportColumnMap = {
  age: 'Age',
  'allocation-status': 'AllocationStatus',
  'amount-paid': 'AmountPaid',
  assignedTo: 'AssignedTo',
  'open-batch-name': 'FulfillmentPlanSet',
  'buyer-id': 'BuyerId',
  buyer: 'Buyer',
  carrier: 'Carrier',
  'client-name': 'Client',
  'company-name': 'CompanyName',
  company: 'ShipToCompany',
  confirmation: 'Confirmation',
  country: 'ShipToCountry',
  custom1: 'CustomField1',
  custom2: 'CustomField2',
  custom3: 'CustomField3',
  gift: 'Gift',
  holdUntil: 'HoldUntil',
  'item-name': 'ItemName',
  'item-sku': 'ItemSku',

  // notes:  'Notes', Coming soon- Jira ticket SPD-9046
  orderDate: 'OrderDate',

  'order-number': 'OrderNumber',
  'order-total': 'OrderTotal',
  package: 'PackageType',
  paidDate: 'PaidDate',
  quantity: 'ItemQuantity',
  rate: 'Rate',
  recipient: 'ShipToName',
  'requested-service': 'RequestedService',
  service: 'Service',
  serviceCollection: 'ServiceCollection',
  'ship-by': 'ShipByDate',
  shipDate: 'ShipDate',
  shipFrom: 'ShipFrom',
  shippingAccount: 'ShippingAccount',
  shippingPaid: 'ShippingPaid',
  source: 'Source',
  state: 'ShipToState',
  status: 'Status',
  store: 'Store',
  tags: 'Tags',
  taxPaid: 'TaxPaid',
  'warehouse-location': 'WarehouseLocation',
  weight: 'Weight',
  zone: 'Zone',
};
